(function ($, Drupal, drupalSettings) {
    'use strict';

    var initialized = false;

    // define some vars
    let g_menuOpen = false;

    Drupal.behaviors.navEcoparc = {
        attach: function (context, setting) {
            if (!initialized) {
                initialized = true;
                Drupal.behaviors.navEcoparc.init();
            }
        },
        init: function () {
            this.initNavigation();
        },

        closeMenu: function () {
            g_menuOpen = false;
        },

        initNavigation: function () {
            $('.mobile-navbar-toggler').off('click').on('click', function (e) {
                e.preventDefault();
                $(this).add('#main-nav-wrapper, body').toggleClass('nav-open');
            })
        },
        openMenu: function () {
            g_menuOpen = true;
        }
    };
})(jQuery, Drupal, drupalSettings);
